<template>
  <div>
    <div class="mb-3">
      <!-- Drag and drop area -->
      <div
        class="file-upload-area p-4 mb-2 border rounded"
        :class="{
          'is-invalid': v$.file.$error,
          'border-primary bg-light': isDragging,
          'border-dashed': !isDragging
        }"
        @dragenter.prevent="isDragging = true"
        @dragover.prevent="isDragging = true"
        @dragleave.prevent="isDragging = false"
        @drop.prevent="onDrop"
      >
        <div class="text-center">
          <div v-if="!file">
            <i class="bi bi-cloud-arrow-up fs-3 mb-2"></i>
            <p class="mb-1">{{ $t('po_ge_tx_drag_drop_files') }}</p>
            <p class="text-muted small">{{ $t('po_ge_tx_or') }}</p>
          </div>

          <div v-else class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="bi bi-file-earmark me-2"></i>
              <span>{{ file.name }}</span>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              @click.prevent="removeFile"
            >
              <i class="bi bi-x"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Hidden file input -->
      <input
        :id="id"
        type="file"
        class="d-none"
        :accept="accept"
        @change="onFileChange"
        ref="fileInput"
        form="FileUploadForm"
      >

      <!-- Browse button -->
      <div class="d-grid">
        <button
          type="button"
          class="btn btn-outline-secondary"
          @click="$refs.fileInput.click()"
          :disabled="!!file"
        >
          {{ $t('po_ge_bt_browse_files') }}
        </button>
      </div>

      <!-- Validation feedback -->
      <div class="invalid-feedback d-block" v-if="v$.file.$error">
        {{ v$.file.$errors[0]?.$message }}
      </div>

      <!-- File size limit info -->
      <small class="text-muted" v-if="maxSizeInMB">
        {{ $t('po_ge_tx_max_file_size', { size: maxSizeInMB }) }}
      </small>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@/config/i18n-validators'

export default {
  name: 'FileUpload',
  props: {
    modelValue: Object,
    id: {
      type: String,
      default: 'file-upload'
    },
    required: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: '*/*'
    },
    maxSizeInMB: {
      type: Number,
      default: 10
    }
  },
  setup () {
    return {
      v$: useVuelidate({ $autoDirty: true })
    }
  },
  data () {
    return {
      isDragging: false
    }
  },
  validations () {
    return {
      file: {
        required: this.required ? required : { },
        validSize: (value) => {
          if (!value) return true
          const maxSizeInBytes = this.maxSizeInMB * 1024 * 1024
          return !this.maxSizeInMB || value.size <= maxSizeInBytes || this.$t('po_ge_tx_file_too_large')
        }
      }
    }
  },
  computed: {
    file: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  methods: {
    onFileChange (event) {
      const files = event.target.files
      if (files.length > 0) {
        this.file = files[0]
      }
    },
    onDrop (event) {
      this.isDragging = false
      const files = event.dataTransfer.files
      if (files.length > 0) {
        this.file = files[0]
      }
    },
    removeFile () {
      this.file = null
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = ''
      }
    }
  }
}
</script>

<style scoped>
.border-dashed {
  border-style: dashed !important;
}
</style>
